module.exports = __webpack_public_path__ + "resources/img/img-logo@2x.1d736f9d.png";